export function toISODateString(date: string): string {
  return date.split('T')[0];
}

export function toISOString(date: Date): string {
  return toISODateString(date.toISOString());
}
